<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_5"><span class="txbf">CONTENTS</span></a><a id="page_6"></a></h2><a id="page_6">
<hr class="hr2"/>
</a><p class="toc"><a id="page_6"></a><a href="#/xhtml/intro"><span class="txbf">INTRODUCTION</span></a></p>
<p class="tocp"><a href="#/xhtml/part01"><span class="txbf">PART 1</span></a></p>
<hr class="hr2c"/>
<p class="tocp1"><a href="#/xhtml/part01">LEARNING TO EMBRACE THE POWER OF YOUR ENERGY</a></p>
<p class="tocc"><a href="#/xhtml/part01#ch01"><span class="txbf">CHAPTER 1:</span> <span class="txit">Awakening to Yourself As an Energetic Being</span></a></p>
<p class="tocc"><a href="#/xhtml/ch02"><span class="txbf">CHAPTER 2:</span> <span class="txit">The Power of Energy</span></a></p>
<p class="toccb"><span href="#/xhtml/ch03" title="Link target outside of Sample"><span class="txbf">CHAPTER 3:</span> <span class="txit">The Miraculous Energy of Self-Love</span></span></p>
<p class="tocp"><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="txbf">PART 2</span></span></p>
<hr class="hr2c"/>
<p class="tocp1"><span href="#/xhtml/part02" title="Link target outside of Sample">WORKING WITH THE ENERGY OF THE UNIVERSE</span></p>
<p class="tocc"><span href="#/xhtml/part02#ch04" title="Link target outside of Sample"><span class="txbf">CHAPTER 4:</span> <span class="txit">Your Creative Powers</span></span></p>
<p class="tocc"><span href="#/xhtml/ch05" title="Link target outside of Sample"><span class="txbf">CHAPTER 5:</span> <span class="txit">Discover Your Purpose</span></span></p>
<p class="tocc"><span href="#/xhtml/ch06" title="Link target outside of Sample"><span class="txbf">CHAPTER 6:</span> <span class="txit">Let the Universe Guide You</span></span></p>
<p class="toccb"><span href="#/xhtml/ch07" title="Link target outside of Sample"><span class="txbf">CHAPTER 7:</span> <span class="txit">Access Your Intuition</span></span></p>
<p class="tocp"><span href="#/xhtml/part03" title="Link target outside of Sample"><span class="txbf">PART 3</span></span></p>
<hr class="hr2c"/>
<p class="tocp1"><span href="#/xhtml/part03" title="Link target outside of Sample">MANIFESTING A POSITIVE LIFE</span></p>
<p class="tocc"><span href="#/xhtml/part03#ch08" title="Link target outside of Sample"><span class="txbf">CHAPTER 8:</span> <span class="txit">Overcome Common Obstacles</span></span></p>
<p class="tocc"><span href="#/xhtml/ch09" title="Link target outside of Sample"><span class="txbf">CHAPTER 9:</span> <span class="txit">Embrace Higher Realms</span></span></p>
<p class="tocc"><span href="#/xhtml/ch10" title="Link target outside of Sample"><span class="txbf">CHAPTER 10:</span> <span class="txit">Heal Your Mind, Body, and Soul</span></span></p>
<p class="toccb"><span href="#/xhtml/ch11" title="Link target outside of Sample"><span class="txbf">CHAPTER 11:</span> <span class="txit">Positive Energy, Positive Life</span></span></p>
<p class="toc"><span href="#/xhtml/final" title="Link target outside of Sample"><span class="txbf">FINAL THOUGHTS</span></span></p>
<p class="toc"><span href="#/xhtml/about" title="Link target outside of Sample"><span class="txbf">ABOUT THE AUTHOR</span></span></p>
<p class="tocn"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="txbf">INDEX</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?d2335044